import React from "react";
import DataManagement from "../../../Components/HomeScreen/HomeScreenData";

function HomeScreen() {
  return (
    <div className="w-full">
      <DataManagement />
    </div>
  );
}

export default HomeScreen;
